<div class="row word-break">
  @if (showThumbnails) {
    <div class="col-3 col-md-2 pe-sm-0">
      @if (linkType !== linkTypes.None) {
        <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
          [routerLink]="[itemPageRoute]" class="dont-break-out" role="link" tabindex="-1">
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
          </ds-thumbnail>
        </a>
      }
      @if (linkType === linkTypes.None) {
        <span class="dont-break-out">
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
          </ds-thumbnail>
        </span>
      }
    </div>
  }
  <div [ngClass]="showThumbnails ? 'col-9 col-xl-10' : 'col-12'">
    <div class="d-flex justify-content-between">
      <div class="flex-fill">
        @if ((hasLoadedThirdPartyMetrics$ | async) !== true && showMetrics) {
          <small class="d-flex text-muted">
            {{ "third-party-metrics-blocked" | translate }}&nbsp;
            <div role="button" class="btn-link" (click)="showSettings()">{{ "third-party-metrics-cookies.consent-settings" | translate }}</div>
          </small>
        }
        <div class="d-flex">
          @if (showLabel) {
            <ds-badges [object]="dso" [context]="context" [showAccessStatus]="true"></ds-badges>
          }
        </div>
        @if (object !== undefined && object !== null) {
          <ds-truncatable [id]="dso.id">
            @if (linkType !== linkTypes.None) {
              <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
                [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out"
              [innerHTML]="dsoTitle | dsEscapeHtml" role="link" tabindex="0"></a>
            }
            @if (linkType === linkTypes.None) {
              <span class="lead item-list-title dont-break-out"
              [innerHTML]="dsoTitle | dsEscapeHtml"></span>
            }
            @if (showWorkflowStatistics) {
              <ds-in-workflow-statistics  [item]="dso"></ds-in-workflow-statistics>
            }
            <span class="text-muted">
              <ds-truncatable-part [id]="dso.id" [minLines]="1">
                @if (dso.firstMetadataValue('dc.publisher') || dso.firstMetadataValue('dc.date.issued')) {
                  (@if (dso.firstMetadataValue('dc.publisher')) {
                  <span class="item-list-publisher" [innerHTML]="firstMetadataValue('dc.publisher')"></span>
                }
                @if (dso.firstMetadataValue('dc.publisher') && dso.firstMetadataValue('dc.date.issued')) {
                  <span>, </span>
                }
                @if (dso.firstMetadataValue('dc.date.issued')) {
                  <span class="item-list-date"
                  [innerHTML]="firstMetadataValue('dc.date.issued')"></span>
                  })
                }
                @if (dso.allMetadataValues(authorMetadata, placeholderFilter).length > 0) {
                  <span class="item-list-authors">
                    <ng-container *ngVar="(isCollapsed() | async) as isCollapsed">
                      @if (isCollapsed) {
                        @for (author of dso.limitedMetadata(authorMetadata, additionalMetadataLimit, placeholderFilter); track author; let i = $index; let last = $last) {
                          <span>
                            <ds-metadata-link-view [item]="dso" [metadata]="author" [metadataName]="authorMetadata"></ds-metadata-link-view>@if (!last) {
                            <span>; </span>
                          }
                        </span>
                      }
                    }
                    @if (!isCollapsed) {
                      @for (author of dso.allMetadata(authorMetadata, placeholderFilter); track author; let i = $index; let last = $last) {
                        <span>
                          <ds-metadata-link-view [item]="dso" [metadata]="author" [metadataName]="authorMetadata"></ds-metadata-link-view>@if (!last) {
                          <span>; </span>
                        }
                      </span>
                    }
                  }
                </ng-container>
              </span>
            }
          </ds-truncatable-part>
        </span>
        @if (dso.firstMetadataValue('dc.description.abstract')) {
          <div class="item-list-abstract">
            <ds-truncatable-part [id]="dso.id" [minLines]="3">
              <span [innerHTML]="firstMetadataValue('dc.description.abstract')"></span>
            </ds-truncatable-part>
          </div>
        }
        <ds-additional-metadata [object]="dso"></ds-additional-metadata>
      </ds-truncatable>
    }
    @if (showMetrics) {
      <ds-metric-badges class="d-block clearfix" [item]="dso"></ds-metric-badges>
    }
  </div>
  @if (showMetrics) {
    <div class="align-self-center">
      <ds-metric-donuts [item]="dso"></ds-metric-donuts>
    </div>
  }
</div>
</div>
</div>
